import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query'

import { signOut } from 'src/app/auth/adapters/knap'
import { useAuthStore } from 'src/app/auth/store/auth-store'

import { authKeys } from './keys'

export const useSignoutMutation = (): UseMutationResult<void, Error, void> => {
  const setCurrentUser = useAuthStore(state => state.setCurrentUser)
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: authKeys.signout(),
    mutationFn: signOut,
    onSettled: () => {
      setCurrentUser(null)
      queryClient.clear()
    },
    meta: { silent: true },
  })
}
